import { generateRepositoryMethods } from './repository.types.js';
export const orderRepositoryMethods = generateRepositoryMethods({
    createOrder: {
        callMethod: 'POST',
        endpoint: '/order/create',
    },
    getNextPlannedReorderDate: {
        callMethod: 'GET',
        endpoint: '/order/planned/next/date',
    },
    getNextOpenOrder: {
        callMethod: 'GET',
        endpoint: '/order/open/next',
    },
    getPaginatedOrders: {
        callMethod: 'GET',
        endpoint: '/order/paginated',
    },
    cancelPlannedOrder: {
        callMethod: 'POST',
        endpoint: '/order/planned/cancel',
    },
    getPlannedOrders: {
        callMethod: 'GET',
        endpoint: '/order/planned',
    },
    getAutomaticOrderableProducts: {
        callMethod: 'GET',
        endpoint: '/automatic-orderable-products/list',
    },
    createAutomaticReorderConfig: {
        callMethod: 'POST',
        endpoint: '/automatic-orderable-products/create-config',
    },
    triggerOrderReminder: {
        callMethod: 'POST',
        endpoint: '/order/trigger-reminder',
    },
    getAllOrderableProducts: {
        callMethod: 'GET',
        endpoint: '/orderable-products/all',
    },
});
//# sourceMappingURL=order.methods.js.map